import React, { useState, useEffect } from "react";
import Table from "../../../../Common/Table";
import { values } from "lodash-es";

const KeyValTable = ({ data = {} }) => {
  function getItems() {
    let items = [];
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        items.push({
          key: key,
          value: data[key],
        });
      }
    }
    return items;
  }

  return (
    <Table
      blankStateComponent={null}
      fields={["key", "value"].map((v) => {
        return {
          heading: v,
          key: v,
        };
      })}
      list={getItems()}
    />
  );
};

export default KeyValTable;
